import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class OptimizeApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Optimize;

  constructor(
    private event: string,
    private category: string
  ) {
  }

  getPayload(): any {
    return {
      event: this.event,
      category: this.category
    };
  }
}
